<template>
    <div style="display:flex;">
        <div style="width: 20%;border: 1px solid #dcdee2;margin-top:1vw;margin-left: 1vw;border-radius: 8px">
            <el-tree :data="data" :props="defaultProps"
                     node-key="spcId"
                     :default-expanded-keys="spcIdList"
                     @node-click="treeNodeSelect">
            </el-tree>
        </div>
        <div class="tableOrgBox">
            <LabelContent :title="$t('Account.spareSort')" ref="LabelContent">
                <div slot="btns">
                    <span v-for="acc in access" :key="acc">
                        <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"
                                 v-if="acc=='SPARETYPE001'">{{$t('base.add')}}
                        </el-button>
                    </span>
                </div>
            </LabelContent>
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="spcName" sortable :label="$t('base.name')"/>
                <el-table-column prop="spcCode" sortable :label="$t('EnumType.code')"/>
                <el-table-column prop="isActive" sortable :label="$t('base.ifEnable')">
                    <template slot-scope="scope">
                        <span>{{scope.row.isActive == true ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="130">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <span v-for="acc in access" :key="acc">
                                <i class="editBtn iconfont u-youjianbianji"
                                @click=";(ifAdd = false), updatehOpen(scope.row)"
                                v-if="acc=='SPARETYPE002'"/>
                                <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"
                                v-if="acc=='SPARETYPE003'"/>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align:left">
            <el-form :model="sparePartClassify" :rules="classify" ref="classify" label-width="100px"
                     class="demo-roleForm">
                <el-form-item :label="$t('base.name')" prop="spcName">
                    <el-input v-model="sparePartClassify.spcName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('EnumType.code')" prop="spcCode">
                    <el-input v-model="sparePartClassify.spcCode" :disabled="codeShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('User.state')">
                    <el-switch v-model="sparePartClassify.isActive"
                               :active-text="$t('User.Yes')"
                               :inactive-text="$t('User.No')"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary"
                           @click="updateSparePartClassify('classify')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { addPartClassify, partClassifyTree } from '../../../libs/api'

    export default {
        name: 'sparePartClassify',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                updateShow: false,
                ifAdd: false,
                codeShow: false,
                sparePartClassify: {
                    fcCode: '',
                    spcCode: '',
                    spcName: '',
                    isActive: '',
                    parentId: ''
                },
                classify: {
                    spcCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    spcName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ]
                },
                treeNodeSelected: {},
                spcIdList: [],
                data: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                fcCode: '',
                spcId: '',
                access: [],
                userInfo: {},
                roles: {}
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.userInfo = this.$store.state.userInfo
                if (this.userInfo.factoryId == 0) {
                    //所有工厂数据
                } else {
                    var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                    this.roles = userInfo.roles
                    for (let i = 0; i < userInfo.roles.length; i++) {
                        if (i == userInfo.roles.length - 1) {
                            this.fcCode += userInfo.roles[i].fcCode
                        } else {
                            this.fcCode += userInfo.roles[i].fcCode + ','
                        }
                    }
                }
                this.searchTable()
                this.partClassifyTree()
            },
            treeNodeSelect(nodes) {
                this.treeNodeSelected = nodes
                this.spcId = nodes.spcId
                this.searchTable()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            updatehOpen(row) {
                //新增
                if (this.ifAdd) {
                    if (this.spcId == undefined || this.spcId == '') {
                        this.$message.error(this.$t('base.PleaseSelect')+' '+this.$t('Account.sort'))
                        return
                    }
                    if (this.treeNodeSelected.classifyLevel == 'c') {
                        return
                    }
                    this.sparePartClassify = {}
                    this.codeShow = false
                    this.sparePartClassify.parentId = this.spcId
                    if (this.userInfo.factoryId != 0) {
                        this.sparePartClassify.fcCode = this.userInfo.fcCode
                    }
                }
                //编辑
                else{
                    this.sparePartClassify = JSON.parse(JSON.stringify(row))
                    this.codeShow = true
                }
                this.updateShow = true
            },
            updateSparePartClassify(classify) {
                this.$refs[classify].validate((valid) => {
                    if (valid) {
                        //ifAdd true新增、false编辑
                        let options = {
                            method: 'POST',
                            url: this.ifAdd ? this.$api.addPartClassify : this.$api.editPartClassify,
                            data: this.sparePartClassify
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.partClassifyTree()
                                this.treeNodeSelect(this.treeNodeSelected)
                                this.$message.success(this.ifAdd ? this.$t('base.SuccessfullyAdded') : this.$t('base.SuccessfullyUpdated'))
                                this.updateShow = false
                            } else {
                                this.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            deleteRow(row) {
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            params: { spcId: row.spcId },
                            url: this.$api.deletePartClassify
                        })
                        .then(response => {
                            this.partClassifyTree()
                            this.treeNodeSelect(this.treeNodeSelected)
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.partClassifyTree()
                            this.treeNodeSelect(this.treeNodeSelected)
                            // this.$message.error(err);
                        })
                }).catch(() => {
                    this.partClassifyTree()
                    this.treeNodeSelect(this.treeNodeSelected)
                    this.$message({
                        type: 'info',
                        message: this.$t('msg.cancel')
                    })
                })
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.spcId != undefined && this.spcId != '') {
                    queryParams['spcId'] = this.spcId
                } else {
                    return
                }
                if (this.userInfo.factoryId != 0) {
                    queryParams['fcCode'] = this.userInfo.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllPartClassify,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            partClassifyTree() {
                let params = {}
                if (this.userInfo.factoryId != 0) {
                    params['fcCode'] = this.userInfo.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.partClassifyTree,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.setPartClassify(response.data)
                    }
                })
            },
            setPartClassify(partTypes) {
                partTypes.forEach(result => {
                    if (result.hasOwnProperty('spcId')) {
                        if (result.child != undefined && result.child != '') {
                            if (result.child[0].hasOwnProperty('spcId')) {
                                this.spcIdList.push(result.spcId)
                            }
                        }
                    }
                    if (result.hasOwnProperty('spcCode')) {
                        result.label = result.spcName
                        result.value = result.spcCode
                        result.children = result.child
                        if (result.child != null) {
                            if (result.child.length > 0) {
                                this.setPartClassify(result.child)
                            }
                        }
                    }
                })
                this.data = partTypes
            }
        }
    }
</script>

<style scoped>

</style>
